export const educationData = [
  {
    id: 1,
    institution: "K J Somaiya Institute of Management",
    course: "Master of Computer Applications (MCA)",
    startYear: "2025",
    endYear: "2027",
    grade: "CGPA: 8.98 / 10",
  },
  {
    id: 2,
    institution: "Mumbai University",
    course: "B.Sc. Information Technology",
    startYear: "2020",
    endYear: "2023",
    grade: "CGPI: 9.73 / 10",
  },
];
